import LoginCheckIcon from '@/components/common/login_check_icon'
import useScreenSize from '@/components/hooks/useScreenSize'
import { MobileSwitch, Text } from '@/components/ui'

const listItems = [
  'Thousands of mental health professionals exchanging high-quality referrals.',
  'A community of vetted mental health professionals.',
  'A curated feed of news stories, articles and headlines for the mental health world.',
  'Publish articles and gain exposure with our nation-wide content distribution.',
  "Find trusted help for clients you can't serve, sitting in your overloaded waitlist.",
]

interface InfoContainterProps {
  isMobileView?: boolean
}
function InfoContainter({ isMobileView = false }: InfoContainterProps) {
  const { isMobile } = useScreenSize()

  return (
    <div className="flex w-full rounded-lg md:rounded-xl bg-purple-main">
      <MobileSwitch
        regularView={
          <div className="flex flex-col items-center justify-around py-[15%] px-[10%]">
            <Text className="text-2xl md:text-3xl lg:text-4xl xl:text-4xl 2xl:text-5xl text-background font-qanelas-extrabold">
              Here&apos;s what&apos;s waiting for you inside...
            </Text>
            <div className="flex flex-col gap-4 px-1 list-none 2xl:gap-6 2xl:px-6">
              {listItems.map((text) => (
                <div
                  key={text}
                  className="flex gap-7 items-start xl:items-center"
                >
                  <LoginCheckIcon className="flex-none w-10 h-10 lg:w-12 lg:h-12" />
                  <Text className="leading-5 lg:leading-5 2xl:text-xl text-md text-background lg:text-md">
                    {text}
                  </Text>
                </div>
              ))}
            </div>
            <Text className="self-center text-lg lg:text-xl 2xl:text-2xl text-background font-qanelas-extrabold">
              Belongly is HIPAA compliant.
            </Text>
          </div>
        }
        mobileView={
          <div className="flex flex-col gap-8 py-14 px-14">
            <Text className="text-2xl md:text-5xl text-background font-qanelas-extrabold">
              Here&apos;s what&apos;s waiting for you inside...
            </Text>
            <div className="flex flex-col gap-4 list-none">
              {listItems.map((text) => (
                <div key={text} className="flex gap-7 items-center">
                  <LoginCheckIcon className="flex-none w-12 h-12" />
                  <Text
                    variant="body"
                    size="lg"
                    className="pr-2 leading-5 text-background"
                  >
                    {text}
                  </Text>
                </div>
              ))}
            </div>
            <Text className="self-center pt-1 text-lg md:text-2xl text-background font-qanelas-extrabold">
              Belongly is HIPAA compliant.
            </Text>
          </div>
        }
      />
    </div>
  )
}

export default InfoContainter
